import { useAuth } from "../../contexts/auth/AppAuthContext";
import { MessageSchema } from "../../firestore/Types/MessageSchema";
import { sendMessage } from "../../firestore/Functions/messageFunctions";
import { useEffect, useState } from "react";
import { TextArea } from "../Common/TextArea";
import { UserProfileView } from "../../firestore/Types/UserProfileSchema";

export function ChatContent( { chatUserProfile, messages }: { chatUserProfile: UserProfileView, messages: MessageSchema[] } ) {
    const { currentUser } = useAuth();
    const [currentMessage, setCurrentMesssage] = useState("");
    const [textError, setTextError] = useState("");
    const [filteredMessages, setFilteredMessages] = useState<MessageSchema[]>([]);

    const timeFormatter = new Intl.DateTimeFormat('en', { hour: '2-digit', minute: '2-digit'});

    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });

    const sendTestMessage = async () => {
        if (currentMessage.trim().length > 0) {
            await sendMessage(chatUserProfile.Id, currentMessage);
            setCurrentMesssage("");
        } else {
            setTextError("Please enter a message");
        }
    }

    const changeCurrentMessage = (name:string,value:string) => {
        setCurrentMesssage(value);
        if (value.trim().length > 0) {
            setTextError("");
        }
    }
    
    function messageSideCss(message: MessageSchema) {
        if (message.SenderId === currentUser?.uid) {
            return "flex-row-reverse";
        } 
        return "flex-row";
    }

    function displayDate(date: Date) {
        const today = new Date();
        if (date.getDate() === today.getDate()) {
            return <div className={"mb-1 mt-1 message-info grow text-center text-xs"}>Today</div>;
        }
        return <div className={"mb-1 mt-1 message-info grow text-center text-xs"}>{dateFormatter.format(date)}</div>;
    }

    function renderMessage(message: MessageSchema, index: number) {
        const messageDate = message.TimeStamp.toDate();
        const today = new Date();
        var showTime = false;
        var showDate = false;
        if (filteredMessages && Math.abs(filteredMessages[index + 1]?.TimeStamp.toDate().getMinutes() - messageDate.getMinutes()) > 5 && today.getDate() === messageDate.getDate()) {
            showTime = true;
        }
        if (filteredMessages && index === filteredMessages.length - 1) {
            showTime = true;
        }
        if (filteredMessages && messageDate.getDate() !== filteredMessages[index - 1]?.TimeStamp.toDate().getDate()) {
            showDate = true;
        }
        return (
            <div className="flex flex-col mb-2" key={index}>
                {showDate && displayDate(messageDate)}
                <div className={"grow flex p-2 " + messageSideCss(message)}>
                    <div className="message-box whitespace-pre-line text-xs">  {message.Message}</div>
                </div>
                {showTime && <div className={"mb-1 message-info grow flex p-2 " + messageSideCss(message)}>{timeFormatter.format(messageDate)}</div>}
            </div>
        )
    }

    useEffect(() => {
        if (messages) {
            setFilteredMessages(messages.filter(message => (message.ReceiverId === chatUserProfile.Id || message.SenderId === chatUserProfile.Id)));
        }
    }, [messages, chatUserProfile]);

    return (
        <>
            <div className="grow overflow-y-auto relative justify-end">
                <div className="absolute-0 min-[100%]">
                    <div className="flex flex-col p-2">
                        {filteredMessages.map((message, index) => {
                            return renderMessage(message as MessageSchema, index)
                        })}  
                    </div>
                </div>
        </div>
         <div className="p-2 gap-4 flex flex-row">
                <TextArea label="" name="messageText" placeholder="Type a message" value={currentMessage} onValueChange={changeCurrentMessage} />
                <button className="primary-button" onClick={sendTestMessage}>Send</button>
            </div>
            {textError.length > 0 ? <div className="text-red-500">{textError}</div> : <></>}
        </>
    );
}